import { useSelector } from 'react-redux';

export type BillingPermissions = {
  canViewBillingSettingsMenuItem: boolean;
  canSelfServeBilling: boolean;
  canViewUsage: boolean;
  canManagePlans: boolean;
  canViewInvoices: boolean;
  canViewPaymentMethods: boolean;
  canEditPaymentMethods: boolean;
};

export const getBillingPermissionFlagsFromSection = (
  settings_section?: any
) => {
  const canViewInvoices = settings_section?.billing_invoices;
  const canViewUsage = settings_section?.billing_usage;
  const canViewPlans = settings_section?.billing_manage_plans?.view;
  const canViewBillingSettings = settings_section?.billing?.view;

  const canViewBillingSettingsMenuItem =
    canViewBillingSettings || canViewPlans || canViewUsage || canViewInvoices;

  const canManagePlans = settings_section?.billing_manage_plans?.edit;

  const canViewPaymentMethods = canViewBillingSettings;
  const canEditPaymentMethods = settings_section?.billing?.edit;

  return {
    canViewBillingSettingsMenuItem,
    canViewUsage,
    canManagePlans,
    canViewInvoices,
    canViewPaymentMethods,
    canEditPaymentMethods,
  };
};

export const getBillingPermissionsFlagsFromBusiness = (business?: any) => {
  const canSelfServeBilling =
    business?.active_licenses?.general?.features?.billing_self_service === true;

  return {
    canSelfServeBilling,
  };
};

export const useBillingPermissions = (): BillingPermissions => {
  const access = useSelector((s: any) => s.authentication.access);
  const business = useSelector(
    ({ authentication }) => authentication?.chosenBusiness
  );

  const {
    canViewBillingSettingsMenuItem,
    canViewUsage,
    canManagePlans,
    canViewInvoices,
    canViewPaymentMethods,
    canEditPaymentMethods,
  } = getBillingPermissionFlagsFromSection(access?.sections?.settings_section);

  const { canSelfServeBilling } =
    getBillingPermissionsFlagsFromBusiness(business);

  return {
    canViewBillingSettingsMenuItem,
    canSelfServeBilling,
    canViewUsage,
    canManagePlans,
    canViewInvoices,
    canViewPaymentMethods,
    canEditPaymentMethods,
  };
};
